import { render, staticRenderFns } from "./ChatChatGame.vue?vue&type=template&id=290b36d5&"
import script from "./ChatChatGame.vue?vue&type=script&lang=js&"
export * from "./ChatChatGame.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports